/**
 * @generated SignedSource<<2ee8713375fb79b28b48377dd2066673>>
 * @relayHash d74c02bb5f354ff3819d9b43f86431af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514

import type { ConcreteRequest } from 'relay-runtime';
export type DatabaseReferenceModalCurrentUserQuery$variables = Record<PropertyKey, never>;
export type DatabaseReferenceModalCurrentUserQuery$data = {
  readonly user: {
    readonly displayName: string | null;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
    readonly id: string | null;
    readonly locale: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type DatabaseReferenceModalCurrentUserQuery = {
  response: DatabaseReferenceModalCurrentUserQuery$data;
  variables: DatabaseReferenceModalCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": (v0/*: any*/)
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": (v0/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "locale"
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DatabaseReferenceModalCurrentUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DatabaseReferenceModalCurrentUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d74c02bb5f354ff3819d9b43f86431af",
    "id": "e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514",
    "metadata": {},
    "name": "DatabaseReferenceModalCurrentUserQuery",
    "operationKind": "query",
    "text": "query DatabaseReferenceModalCurrentUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale}}"
  }
};
})();

(node as any).hash = "da5e7e584d6c779f02f908f5482b3187";

export default node;
